var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RepairFacilityDetailsCtrl = function () {
    function RepairFacilityDetailsCtrl(StateUtils) {
        _classCallCheck(this, RepairFacilityDetailsCtrl);

        this.StateUtils = StateUtils;
    }

    _createClass(RepairFacilityDetailsCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.flowModel = this.StateUtils.activeDataForState(true).flowModel;
            if (!this.flowModel) {
                throw new Error('Missing flowModel property for current step in the wizard');
            }
        }
    }, {
        key: 'getFirstAddressLine',
        value: function getFirstAddressLine() {
            return this.repairFacility.primaryAddress.addressLine1;
        }
    }, {
        key: 'getSecondAddressLine',
        value: function getSecondAddressLine() {
            var primaryAddress = this.repairFacility.primaryAddress;

            return primaryAddress.city + ', ' + primaryAddress.state + ' ' + primaryAddress.postalCode;
        }
    }, {
        key: 'acceptRepair',
        value: function acceptRepair() {
            var _StateUtils$activeDat = this.StateUtils.activeDataForState(true),
                model = _StateUtils$activeDat.model;

            this.flowModel.next(model).then(this.onAccepted);
        }
    }]);

    return RepairFacilityDetailsCtrl;
}();

RepairFacilityDetailsCtrl.$inject = ['StateUtils'];
export default RepairFacilityDetailsCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/pa/components/RepairFacilityDetails/RepairFacilityDetailsCtrl.js
// module id = 1570
// module chunks = 0